export default "__VITE_ASSET__zs9rLVvS__"